/*
 * @Author: christineqiu@aijiatui.com christineqiu@aijiatui.com
 * @Date: 2024-12-27 10:01:37
 * @LastEditors: christineqiu@aijiatui.com christineqiu@aijiatui.com
 * @LastEditTime: 2025-01-09 16:25:15
 * @FilePath: /management-portal/src/config/theme.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { storage } from '@/utils/storage';

const defaultThemeSetting = {
  isDark: false, // 暗黑模式
  themeColor: '', // 主题色
  menuMode: 'light', // 菜单栏模式(light|dark)
  breadCrumb: true, // 是否显示面包屑
  navTab: true, // 是否开启多页签
  navTabIcon: true, // 是否开启多页签图标
  menuUnique: false, // 只展开一个一级菜单
  grayMode: false, // 是否灰色模式
  animateMode: 'zoom-fade' // 动画
};

export const initThemeSetting = (): typeof defaultThemeSetting => {
  const themeSetting = storage.get('themeSetting');
  return themeSetting ? themeSetting : defaultThemeSetting;
};
